<template>
  <div v-if="visible" class="xai-password-rules">
    <p class="xai-password-rules__heading">PASSWORD RULES</p>
    <ul class="xai-password-rules__list">
      <li v-for="rule in evaluatedRules"
          :key="rule.key"
          class="xai-password-rules__item"
          :class="rule.passing ? 'xai-password-rules__item--pass' : 'xai-password-rules__item--fail'">
        <i :class="rule.passing ? 'wkce-icon-check-circle' : 'wkce-icon-filled-times-circle'"
           aria-hidden="true" />
        <span>{{ rule.text }}</span>
      </li>
    </ul>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { XAI_FREE_TRIAL_PASSWORD_RULES } from '_acaSrc/utility/constants';

const props = defineProps({
    password: {
        type: String,
        default: ''
    },
    visible: {
        type: Boolean,
        default: false
    }
});

const evaluatedRules = computed(() =>
    XAI_FREE_TRIAL_PASSWORD_RULES.map(rule => ({
        key: rule.key,
        text: rule.text,
        passing: props.password.length > 0 && rule.test(props.password)
    }))
);
</script>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

.xai-password-rules {
  background-color: @WKCE-WHITE;
  border-radius: 8px;
  padding: 12px 16px;
  box-sizing: border-box;
  width: 100%;
}

.xai-password-rules__heading {
  .ds1-ma-0();
  .ds1-mb-1();
  font-size: 11px;
  .ds1-utd-weight-600();
  letter-spacing: 0.5px;
  color: @WKCE-GRAY-SHADE1;
  text-transform: uppercase;
}

.xai-password-rules__list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.xai-password-rules__item {
  display: flex;
  align-items: center;
  gap: 8px;
  .ds1-utd-size-2();
}

.xai-password-rules__item--pass {
  i {
    color: @WKCE-GREEN-SHADE1;
  }
}

.xai-password-rules__item--fail {
  color: @WKCE-RED;
}
</style>

